var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import './search.module.css';
import { IconButton } from '../../buttons/iconButton/IconButton';
import clsx from 'clsx';
import styles from './search.module.css';
import { Icons, IconSizes } from '../../icons/icons';
import Icon from '../../media/icon/Icon';
export var Search = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.hasBackButton, hasBackButton = _d === void 0 ? false : _d, _e = _a.hasSubmitButton, hasSubmitButton = _e === void 0 ? true : _e, _f = _a.isSubmitButtonDisabled, isSubmitButtonDisabled = _f === void 0 ? false : _f, _g = _a.autocomplete, autocomplete = _g === void 0 ? 'off' : _g, onBackClick = _a.onBackClick, onSearchClick = _a.onSearchClick, onInputBlur = _a.onInputBlur, onInputChange = _a.onInputChange, onInputFocus = _a.onInputFocus, _h = _a.id, id = _h === void 0 ? '' : _h, props = __rest(_a, ["placeholder", "isDisabled", "hasBackButton", "hasSubmitButton", "isSubmitButtonDisabled", "autocomplete", "onBackClick", "onSearchClick", "onInputBlur", "onInputChange", "onInputFocus", "id"]);
    var inputRef = useRef(null);
    var clearInput = function () {
        inputRef.current.value = '';
    };
    return (_jsx("div", __assign({ className: clsx(styles.search, isDisabled && styles.searchDisabled) }, props, { children: _jsxs("label", __assign({ className: clsx(styles.searchLabel, hasBackButton && !hasSubmitButton && styles.searchLabelBack, !hasBackButton &&
                hasSubmitButton &&
                styles.searchLabelSubmit, hasBackButton &&
                hasSubmitButton &&
                styles.searchLabelBackSubmit) }, { children: [hasBackButton && (_jsx(IconButton, { extraClass: 'backButton', icon: Icons.CH_LEFT, type: 'clear', size: IconSizes.S, onClick: onBackClick, iconColor: 'blue' })), _jsx(Icon, { extraClass: 'iconBefore', icon: Icons.SEARCH }), _jsx("input", { className: styles.searchInput, type: 'text', disabled: isDisabled, placeholder: placeholder, autoComplete: autocomplete, id: id, onBlur: onInputBlur, onChange: onInputChange, onFocus: onInputFocus, ref: inputRef }), _jsx(IconButton, { extraClass: 'iconAfterClear', icon: Icons.CROSS, type: 'clear', size: IconSizes.XS, radius: 'full', onClick: clearInput }), hasSubmitButton && (_jsx(IconButton, { extraClass: 'iconAfterSearch', radius: 'none', icon: Icons.SEARCH, type: isSubmitButtonDisabled ? 'disabled' : 'primary', onClick: isSubmitButtonDisabled ? undefined : onSearchClick }))] })) })));
};
export default Search;
